import { TableCell } from './Cell';
import { TableHeading } from './Heading';
import { TableRoot } from './Root';
import { TableRow } from './Row';

export type { TableCellProps } from './Cell';
export type { TableHeadingProps } from './Heading';
export type { TableRootProps } from './Root';
export type { TableRowProps } from './Row';

export const Table = {
  Root: TableRoot,
  Row: TableRow,
  Cell: TableCell,
  Heading: TableHeading,
};
